import { render, staticRenderFns } from "./CompanionCustomer.vue?vue&type=template&id=7029c9e7&scoped=true"
import script from "./CompanionCustomer.vue?vue&type=script&lang=js"
export * from "./CompanionCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7029c9e7",
  null
  
)

export default component.exports